import { render, staticRenderFns } from "./NewsletterConfirm.vue?vue&type=template&id=6d20b85e&scoped=true"
import script from "./NewsletterConfirm.vue?vue&type=script&lang=js"
export * from "./NewsletterConfirm.vue?vue&type=script&lang=js"
import style0 from "./NewsletterConfirm.vue?vue&type=style&index=0&id=6d20b85e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d20b85e",
  null
  
)

export default component.exports